export default __webpack_public_path__ + "static/AppMoneyWalkie7-1b58b6f3f9340098b963484db062d353.png";